<div class="jobs">
	<div class="container">
		<div class="innerpage-heading">Jobs</div>
		<ul class="nav nav-pills job-list">
			<li> <a routerLink="/all-jobs">All Jobs</a> </li>
			<li><a routerLink="/applied-jobs">Applied Jobs</a> </li>
			<li class="active"><a routerLink="/saved-jobs">Saved Jobs</a> </li>
		</ul>
	</div>
	<section class="pd-tb-3">
		<div *ngIf="jobsData.length > 0" class="container infinite-scroll scrollbar" id="style-1" infinite-scroll [infiniteScrollDistance]="modalScrollDistance"
			[infiniteScrollThrottle]="modalScrollThrottle" [scrollWindow]="false" (scrolled)="onModalScrollDown()">
			<div class="row">
				<div class="col-xl-12 col-lg-12 col-md-12 col-sm-12" *ngFor="let job of jobsData">
					<div *ngIf="jobsData.length > 0">
						<app-applied-saved-jobs-item [job]="job?.job_post" [routerLink]="'/detail/' + job?.job_post?.id"
							[queryParams]="{type: 'saved'}"
							(onJobSaved)="onJobSaved($event)"></app-applied-saved-jobs-item>
					</div>
				</div>
			</div>
			
		</div>
		<div class="noDataFound" *ngIf="jobsData.length == 0 && noData">
			<h2>No Records Found</h2>
		</div>
	</section>
</div>